import { render, staticRenderFns } from "./radio-group.vue?vue&type=template&id=f0a93c8a&scoped=true&"
import script from "./radio-group.ts?vue&type=script&lang=ts&"
export * from "./radio-group.ts?vue&type=script&lang=ts&"
import style0 from "./radio-group.scss?vue&type=style&index=0&id=f0a93c8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0a93c8a",
  null
  
)

export default component.exports